export default __webpack_public_path__ + "static/media/pagination.d6d91a9c.svg";